'use strict';

import $ from 'jquery';
window.$ = window.jQuery = $;

$(function () {
  $('.voucherThumb').on('click', function (event) {
    event.preventDefault();
    var newImage = $(this).data('src');
    var imageId = $(this).data('id');
    $('#flyId').attr('src', newImage);
    $('#voucherImageId').val(imageId);
  });

  $('.shipping-options')
    .find('.shipping-toggle')
    .click(function () {
      //Expand or collapse this panel
      $(this).next().slideToggle('fast');

      //Hide the other panels
      $('.shipping-content').not($(this).next()).slideUp('fast');
    });

  //delay to only fire ajax after the user has stopped typing for a specified amount of time:
  var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  $('#giftBag').on('change', function (event) {
    delay(function () {
      //Get the form data
      var form_data = $('#giftBagOptOut').serializeArray();

      // ajax it over to the server
      $.ajax({
        type: 'POST',
        url: '',
        dataType: 'json',
        data: form_data,
        success: function (response) {
          if (response.success) {
            console.log('Success!');
          } else {
            console.log('Failure!');
          }
        },
      });
    }, 1000);
  });

  $('#orderNotes').on('keyup', function () {
    delay(function () {
      //Get the form data
      var form_data = $('#addNote').serializeArray();

      // ajax it over to the server
      $.ajax({
        type: 'POST',
        url: '',
        dataType: 'json',
        data: form_data,
        success: function (response) {
          if (response.success) {
            console.log('Success!');
          } else {
            console.log('Failure!');
          }
        },
      });
    }, 1000);
  });
});
